<template>
  <div class="card p-10">
    <RequiredText></RequiredText>
    <form id="paymentForm" @submit.prevent="submitForm">
      <div class="p-5 mb-10">
        <div class="row">
          <Input
              containerClass="form-group col-12 col-md-4 mt-auto mb-5"
              :name="`subject`"
              type="text"
              :label="$t('appointments.label.subject')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="true" size="lg"
              v-model="formData.title"
          />
          <Select2
              container-class="form-group col-12 col-md-3 mt-auto mb-5"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="`canal`"
              :isRequired="false"
              :label="$t('appointment_types.title')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('appointment_types.title')"
              v-model="formData.appointment_type_id"
              :IsInputGroup="$can(abilities.CREATE_APPOINTMENT_TYPE)"
              icon="bi bi-plus"
              :clickAddon="openTypeModal"
          >
            <option v-for="(item, index) in getTypes" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </Select2>
          <Select2
              container-class="form-group col-12 col-md-3 mt-auto mb-5"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="`room`+id"
              :isRequired="true"
              :label="$t('appointments.room')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('appointments.select_room')"
              v-model="formData.appointment_room_id"
              :IsInputGroup="true"
              icon="bi bi-plus"
              :clickAddon="openRoomModal"
          >
            <option v-for="(item, index) in getRooms" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </Select2>
          <div class="col-12 col-md-2 mt-10 mb-5 justify-content-end form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" id="flexCheckChecked"
                  v-model="online"
                  checked="checked" />
            <label class="form-check-label" for="flexCheckChecked">{{ $t('appointments.label.meeting') }}</label>
          </div>
        </div>
        <div class="row">
          <Input
              containerClass="form-group col-12 col-md-3 col-lg-3 mt-auto mb-5"
              :name="`location`"
              type="text"
              :label="$t('appointments.label.place')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="true" size="lg"
              v-model="formData.location"
              :placeholder="$t('appointments.label.place_text')"
          />
          <Input
              containerClass="form-group col-12 col-md-3 col-lg-3 mt-auto mb-5"
              :name="`link`"
              type="url"
              :label="$t('appointments.label.link')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="false" size="lg"
              v-model="formData.link"
              :placeholder="$t('appointments.label.link')"
          />
          <InputDate
              containerClass="col-12 col-md-3 mt-auto mb-5"
              name="appointments-start_time"
              :label="$t('appointments.label.start_date_hour')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-sm form-control-solid'"
              :isRequired="true" size="lg"
              dateFormat="d-m-Y H:i"
              :enableTime="true"
              :placeholder="$t('appointments.label.start_date_hour')"
              v-model="formData.start_time"
          />
          <InputDate
              containerClass="col-12 col-md-3 mt-auto mb-5"
              name="appointments-end_time"
              :label="$t('appointments.label.end_date_hour')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-sm form-control-solid'"
              :isRequired="true" size="lg"
              dateFormat="d-m-Y H:i"
              :enableTime="true"
              :placeholder="$t('appointments.label.end_date_hour')"
              v-model="formData.end_time"
          />
        </div>
        <div class="mb-5">
            <div class="form-check form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox" name="is_recurring" id="flexCheckChecked"
                    v-model="formData.is_recurring"
                    checked="checked" />
                <label class="form-check-label" for="flexCheckChecked">{{ $t('appointments.recurrence') }}</label>
            </div>
        </div>
        <div class="row" v-show="formData.is_recurring">
          <div class="col-12 col-md-6 col-lg-6"> 
            <label class="form-label fs-6 text-black">{{ $t('appointments.label.frequence') }}</label>
            <div class="input-group">
              <Input
                  containerClass="form-group col-3 col-md-3 col-lg-3 mt-auto mb-5"
                  :name="`frequence_number`"
                  type="number"
                  :min="0"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false"
                  v-model="formData.frequency_count"
                  :placeholder="$t('appointments.label.placeholder_reminder_number')"
              />
              <CustomSelect2
                  container-class="form-group col-9 col-md-9 col-lg-9 mt-auto mb-5"
                  :multiple="false"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="`recurrence`"
                  :isRequired="false"
                  :placeholder-text="$t('appointments.label.placeholder_recurrence')"
                  :IsInputGroup="true"
                  v-model="formData.frequency"
              >
                <option v-for="(item, index) in recurrenceFrequencyEnum" :key="index" :value="item.value">
                  {{ item[locale] }}
                </option>
                <template #custom>
                  <div class="icon-wrapper">
                    <i class="fas fa-calendar" style="color: rgba(100, 110, 123, 1)"></i>
                  </div>
                </template>
              </CustomSelect2>
            </div>
          </div>
          <Select2
              :container-class="formData.limit_by == 'none' ? 'form-group col-12 col-md-6 col-lg-6 mt-auto mb-5' : 'form-group col-12 col-md-3 col-lg-3 mt-auto mb-5'"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="`stop`"
              :isRequired="false"
              :label="$t('appointments.label.stop')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('appointments.label.stop')"
              v-model="formData.limit_by"
          >
            <option v-for="(item, index) in recurrenceLimitEnum" :key="index" :value="item.value">
              {{ item[locale] }}
            </option>
          </Select2>
          <InputDate
              containerClass="col-12 col-md-3 mt-auto mb-5"
              name="appointments-recurrence_end_time"
              :label="$t('appointments.label.end_date_recurrence')"
              labelClass="form-label fs-6 text-black"
              dateFormat="dd-MM-yyyy"
              :inputClass="'form-control form-control-sm form-control-solid'"
              :isRequired="formData.limit_by == 'date'" size="lg"
              :placeholder="$t('appointments.label.end_date_recurrence')"
              v-model="formData.limit_date"
              v-if="formData.limit_by == 'date'"
          />
          <Input
              containerClass="form-group col-12 col-md-3 mt-auto mb-5"
              :name="`limit_count`"
              type="number"
              :min="0"
              :label="$t('appointments.label.limit_count')"
              labelClass="form-label fs-6 text-black"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="formData.limit_by == 'count'"
              v-if="formData.limit_by == 'count'"
              v-model="formData.limit_count"
          />
        </div>
        <div class="row mb-5">
          <div :class="(currentSociety?.longitude || currentSociety?.latitude) && past ? 'col-12 col-md-5 col-lg-5' : past ? 'col-12 col-md-6 col-lg-6' : ''"> 
            <label v-if="past" class="form-label fs-6 text-black">{{ $t('appointments.label.reminder') }}<span v-if="past" class="ms-2 text-danger">*</span></label>
            <div class="input-group">
              <Input
                  containerClass="form-group col-3 col-md-3 col-lg-3 mt-auto mb-5"
                  :name="`frequence_number`"
                  type="number"
                  :min="0"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="past"
                  :placeholder="$t('appointments.label.placeholder_reminder_number')"
                  v-if="past"
                  v-model="formData.frequency_count_appointment"
              />
              <Select2
                  container-class="form-group col-9 col-md-9 col-lg-9 mt-auto mb-5"
                  :multiple="false"
                  :show-search="true"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :name="`reminder`"
                  :isRequired="past"
                  v-if="past"
                  :placeholder-text="$t('appointments.label.placeholder_reminder')"
                  v-model="formData.frequency_appointment"
              >
                <option v-for="(item, index) in frequencyEnum" :key="index" :value="item.value">
                  {{ item[locale] }}
                </option>
              </Select2>
            </div>
          </div>

          <div class="col-12 col-md-2 col-lg-2 d-flex justify-content-end align-items-center" v-if="currentSociety?.longitude || currentSociety?.latitude">
            <CheckboxInput
                :label="$t('appointments.send_locate')"
                labelClass="ms-3 text-black"
                :is-required="false"
                v-model="formData.send_location"
                :bottom="false"/>
          </div>
        </div>
        <div class="row">

          <div class="col-md-6">
            <div class="h-100 mb-20">
              <CKEditor
                  labelClass="form-label fs-6 text-black"
                  :label="$t('appointments.label.description')"
                  :required="false"
                  id="appointments-description"
                  :content="formData.description"
                  containerClass="h-250px"
                  @text="getDescription"
              />
            </div>
          </div>
          <div class="col-md-6">
            <Select2
                container-class="form-group col-12 mt-auto mb-5"
                :multiple="true"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                :name="`project`+id"
                :isRequired="false"
                :label="$t('appointments.project')"
                labelClass="form-label fs-6 text-black"
                :placeholder-text="$t('appointments.select_project')"
                v-model="formData.model_ids"
                icon="bi bi-plus"
            >
              <option v-for="(item, index) in projects" :key="index" :value="item.id">
                {{ item.title }}
              </option>
            </Select2>
          </div>
        </div>


        <div class="row d-flex align-items-start mt-10">
          <Select2
              container-class="form-group col-12 col-md-4 col-lg-4"
              :multiple="true"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="`contacts`"
              :isRequired="false"
              :label="$t('appointments.label.invite_contacts')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('appointments.label.invite_contacts')"
              v-model="formData.contacts"
          >
            <option v-for="(contact, index) in contacts" :key="index" :value="contact.id">
              {{ contact.fullname }}
            </option>
          </Select2>
          
          <Select2
              container-class="form-group col-12 col-md-4 col-lg-4"
              :multiple="true"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="`users`"
              :isRequired="false"
              :label="$t('appointments.label.invite_users')"
              labelClass="form-label fs-6 text-black"
              :placeholder-text="$t('appointments.label.invite_users')"
              v-model="formData.users"
          >
            <option v-for="(user, index) in users" :key="index" :value="user.id">
              {{ user.fullname }}
            </option>
          </Select2>
          
          <TagifyInput
              containerClass="form-group col-12 col-md-4 col-lg-4"
              type="email"
              :inputClass="'form-control form-control-lg form-control-solid'"
              size="lg"
              :label="$t('appointments.label.guest_emails')"
              labelClass="form-label fs-6 text-black"
              v-model="formData.guest_emails"
              :name="`appointments-guest_emails`"
              :helperText="$t('appointments.label.guest_emails_text')"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end mt-10">
        <Button type="cancel" @click="cancel" btn-class="btn-sm me-2" btn-text="button.cancel" size="7px 30px"></Button>
        <Button type="submit" btn-class="btn-sm me-2" btn-text="button.save" size="7px 30px" :isLoading="submitting"></Button>
      </div>
    </form>
  </div>
  <CreateAppointmentType id="create_type_modal" @load="loadType" @addType="selectedType"/>
  <CreateAppointmentRoom id="create_room_modal" @load="loadRoom" @addRoom="selectedRoom"/>
</template>

<script setup>
import {useStore} from "vuex";
import {computed, defineProps, watch, ref, onMounted} from "vue";
import InputDate from "@/components/InputDate.vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import CKEditor from "@/components/CKEditor.vue";
import Button from "@/components/Button.vue";
import { useRouter } from 'vue-router';
import TagifyInput from "@/components/TagifyInput.vue";
import RequiredText from "@/components/RequiredText.vue"
import CustomSelect2 from "@/components/CustomSelect2.vue";
import {useLocales} from "@/composables/locales";
import CreateAppointmentType from "@/Modules/CRM/components/Modals/AppointmentType/CreateAppointmentType.vue";
import {compareDateToToday} from "@/mixins/Helpers"
import abilities from "@/composables/abilities";
import CheckboxInput from '@/components/CheckboxInput.vue';
import CreateAppointmentRoom from "@/Modules/CRM/components/Modals/Room/CreateAppointmentRoom.vue";
import TagInput from "@/components/Form/TagInput";

const {locale} = useLocales()
const store = useStore()
const router = useRouter()

const props = defineProps({
  appointment: {
    type: Object,
    default: () => ({
      id: null,
      title: '',
      appointment_type_id: '',
      appointment_room_id: '',
      start_time: '',
      end_time: '',
      description: '',
      location: '',
      guest_emails: [],
      contacts: [],
      users: [],
      link: '',
      time_zone_id: '',
      is_recurring: false,
      frequency_appointment: '',
      frequency_count_appointment: null,
      recurring_date: null,
      frequency: '',
      limit_by: 'none',
      limit_count: null,
      frequency_count: null,
      limit_date: null,
      sent_email: false,
      send_location: false,
      model_ids: []

    })
  },
  submitForm: Function,
  submitting: {type: Boolean, default: false}
})

const formData = ref(props.appointment)
const online = ref(false)

const getTypes = computed(() => store.getters['appointmentTypes/getAppointmentTypes'])
const getRooms = computed(() => store.getters['rooms/getRooms'])
const contacts = computed(() => store.getters["contacts/getContacts"])

const users = computed(() => store.getters["user/getUsers"])
const frequencyEnum = computed(() => store.getters["appointments/getFrequencyEnum"])
const recurrenceLimitEnum = computed(() => store.getters["appointments/getRecurrenceLimitEnum"])
const recurrenceFrequencyEnum = computed(() => store.getters["appointments/getRecurrenceFrequencyEnum"])
const projects = computed(() => store.getters['projects/getProjectsCollection'])

const past = computed(() => {
  return compareDateToToday(formData.value.start_time)
})
const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

watch(() => online.value, (value) => {
  formData.value.start_time = moment().format('DD-MM-YYYY H:mm')
  formData.value.end_time = moment().format('DD-MM-YYYY H:mm')
})


function parseCustomDate(dateStr) {
  if(dateStr){
    const [date, time] = dateStr.split(' ');
    const [day, month, year] = date.split('-');
    return new Date(`${year}-${month}-${day}T${time}`);
  }
}

function cancel(){
  router.push({ name: 'appointments'})
}

function openTypeModal(){
  $('#create_type_modal').modal('toggle')
}

function openRoomModal(){
  $('#create_room_modal').modal('toggle')
}

function getDescription(text) {
  formData.value.description = text
}

function loadType(){
  store.dispatch('appointmentTypes/loadAppointmentTypes')
}

function loadRoom(){
  store.dispatch('rooms/loadRooms')
}

function selectedType(id){
  formData.value.appointment_type_id = id
}

function selectedRoom(id){
  formData.value.appointment_room_id = id
}

onMounted(() => {
  store.dispatch('contacts/loadContacts')
  store.dispatch('user/loadUsers')
  loadType()  
  loadRoom()
  store.dispatch('appointments/loadFrequencyEnum')
  store.dispatch('appointments/loadRecurrenceLimitEnum')
  store.dispatch('appointments/loadRecurrenceFrequencyEnum')
  store.dispatch("projects/loadProjectsCollection")

})
</script>

<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>

